import { useCallback } from "react"
import { batch, useComputed, useSignal } from "@preact/signals-react"
import { useToast } from "@hooks"
import { postSubmit } from "@ui-seeker/utils"
import { multipleModalIds, multipleUsersModalOption } from "Pages/Admin/Users/@signals"

export default function useEditUsersModal() {

	const isSubmitLoading = useSignal(false)
	const selectorData = useSignal([])
	const modalPayload = useComputed(() => ({ users: multipleModalIds.value, values: selectorData.value, operation: multipleUsersModalOption.value }))
	const { showToast } = useToast()


	const setSelectorData = value => {
		selectorData.value = value
	}

	const handleSubmit = useCallback((data, url) => {
		if (!data.values?.length || !data.users?.length) return
		isSubmitLoading.value = true
		postSubmit(url, data)
			.then(() => batch(() => {
				showToast.success("Users updated successfully!")
				multipleModalIds.value = []
				multipleUsersModalOption.value = null
				selectorData.value = []
				isSubmitLoading.value = false
			}))
			.catch(() => {
				showToast.error("An error happened editing those users")
				isSubmitLoading.value = false
			})
	}, [])

	return {
		handleSubmit,
		setSelectorData,
		modalPayload: modalPayload.value,
		isSubmitLoading: isSubmitLoading.value,
		selectorData: selectorData.value,
	}

}